/* eslint react/prefer-stateless-function: "off" */
import React, { PureComponent } from 'react';
import { BackboneViewWrapper } from 'bv-components';
import withVisibility from '../hocs/with_visibility';

const { BetslipView } = window;

class Betslip extends PureComponent {
  render() {
    return <BackboneViewWrapper backboneView={new BetslipView()} />;
  }
}

export default withVisibility('betslip')(Betslip);
